import type { CopilotCatchUpCardProps } from './components/CopilotCatchUpCard';
import type { CopilotCatchUpNavigationProps } from './components/CopilotCatchUpNavigation';
import type { CopilotHeadlinesRollupProps } from './components/CopilotHeadlinesRollup';
import type { CopilotHeadlinesButtonProps } from './components/CopilotHeadlinesButton';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotCatchUp" */ './lazyIndex'),
    { name: 'CopilotCatchUp' }
);

// Components
export const LazyCopilotHeadlinesButton: LazyComponent<CopilotHeadlinesButtonProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotHeadlinesButton);
export const LazyCopilotHeadlinesRollup: LazyComponent<CopilotHeadlinesRollupProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotHeadlinesRollup);
export const LazyCopilotCatchUpNavigation: LazyComponent<
    CopilotCatchUpNavigationProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.CopilotCatchUpNavigation);
export const LazyCopilotCatchUpCard: LazyComponent<CopilotCatchUpCardProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCatchUpCard);

// Lazy Actions
export const lazyOnCopilotHeadlinesButtonClickedMutator: LazyAction<
    typeof lazyIndex.onCopilotHeadlinesButtonClickedMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onCopilotHeadlinesButtonClickedMutator);

export const lazyGenerateCopilotHeadlines: LazyAction<
    typeof lazyIndex.generateCopilotHeadlines,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.generateCopilotHeadlines);
